module.exports = "/images/cart.svg";